/**
 * 批量修改处理人
 */
import React, { useState, useEffect, useRef, useReducer } from 'react';
import { Form, Button, Select, Row, Col, message, Input, Spin, ConfigProvider, Radio } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import {SFuncModal} from "shj-components";
import {iiHOC} from "@/utils/auth.ts";
import arrToListOption from "@/pages/homePage/components/addMatter";
import {ticketsBatchUpdateDisposePerson} from "@/services/customerServices.ts";
import {httpOrgList} from "@/services/homeService.ts";
import {getEmployeeSearchByOrgIdList} from "@/services/channelManagement.ts";
import {isArray} from "lodash-es";
const { TextArea } = Input;

export const ModaleditDisposePersonTab = (props: any) => <ModaleditDisposePersonDom {...props} />;

export function modaleditDisposePersonFn(val: any) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `批量修改处理人`,
    vanish: true,
    content: (
      <>
        <ConfigProvider locale={zhCN}>
          <ModaleditDisposePersonDom onClose={onClose} {...val} />
        </ConfigProvider>
      </>
    ),
  });
  return dialog;
}

const ModaleditDisposePersonDom = (params: any) => {
  const { onClose, fn, ids, issueId, formOnly } = params;
  const formNode = useRef<any>();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isSpecial, setIsSpecial] = useState(false);
  const [spinLoading, setSpinLoading] = useState(false);
  const [staffList, setStaffList]: any[] = useState([]);
  const [staffSelList, setStaffSelList]: any[] = useState([]);
  const [state, dispatch] = useReducer(
    (state, action) => {
      return action;
    },
    {
      companyList: [],
    },
  );
  useEffect(() => {
    initFn();
  }, []);
  const btnStatus = (otherStatus: boolean) => {
    if (isSpecial) {
      return false;
    }
    return otherStatus;
  };

  const onChangePerson = (data) => {
    setStaffSelList( {name: data.userName, ucenterUserId: data.ucenterUserId})
  }

  const onCompanyChange = async (val: any) => {
    console.log(val)
    setSpinLoading(true);
    try {
      return await new Promise((resolve, reject) => {
        Promise.all([getEmployeeSearchByOrgIdList(val)])
          .then((resp) => {
            setStaffList(resp[0]);
            form.resetFields(['old', 'new']);
            form.setFieldsValue({ old: undefined, new: undefined });
            setSpinLoading(false);
          })
          .catch((err) => {
            setSpinLoading(false);
          });
      });
    } catch (err) {
      setSpinLoading(false);
    }
  };

  const initFn = async () => {
    setSpinLoading(true);
    return new Promise((resolve, reject) => {
      Promise.all([httpOrgList()])
        .then((resp) => {
          const listObj = {
            companyList: [...resp[0]],
          };
          dispatch(listObj);
        })
        .catch((err) => {
          setSpinLoading(false);
        });
      setSpinLoading(false);
    }).catch((err) => {
      setSpinLoading(false);
    });
  };

  const onFinish = () => {
    form.validateFields().then(values=>{
      if (loading) return;
      setLoading(true);
      ticketsBatchUpdateDisposePerson({staff: staffSelList, ids}).then(res => {
        message.success(res.message || '操作成功');
        onClose()
        fn?.()
      }).finally(() => setLoading(false))
    })
  };
  const { companyList } = state;
  return iiHOC(
    <SFuncModal.Content
    onCancel={onClose}
    onOk={onFinish}
    confirmLoading={loading}
    >
      <Spin spinning={spinLoading} tip="加载中...">
        <Form
          ref={formNode}
          form={form}
          {...{
            labelCol: {
              xs: { span: 12 },
              sm: { span: 6 },
            },
            wrapperCol: {
              xs: { span: 12 },
              sm: { span: 18 },
            },
          }}
        >
          <Row gutter={2}>
            <Col span={24}>
              <Form.Item label="门店" name="companyCode" required rules={[{ required: true, message: '请选择' }]}>
                <Select
                  disabled={btnStatus(false)}
                  placeholder="请选择"
                  allowClear
                  showSearch
                  options={companyList}
                  fieldNames={{label: 'name', value: 'id'}}
                  onChange={(value) => {
                    onCompanyChange(value);
                  }}
                />
              </Form.Item>
            </Col>

            {/* <Col span={24}>
              <Form.Item label="原处理人" name="old" required rules={[{ required: true, message: '请选择' }]}>
                <Select
                  disabled={btnStatus(false)}
                  placeholder="请选择"
                  allowClear
                  showSearch
                  filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                >
                  {arrToListOption(staffList, { value: 'submitEvent', title: 'echoText' })}
                </Select>
              </Form.Item>
            </Col> */}
            <Col span={24}>
              <Form.Item label="现处理人" name="new" required rules={[{ required: true, message: '请选择' }]}>
                <Select
                  disabled={btnStatus(false)}
                  placeholder="请选择"
                  options={staffList}
                  fieldNames={{label: 'userName', value: 'ucenterUserId'}}
                  allowClear
                  showSearch
                  onChange={(_,v) => onChangePerson(v)}
                  optionFilterProp={'userName'}
                />
              </Form.Item>
            </Col>
           {/* <Col span={24} style={{ textAlign: 'right' }}>
              {!formOnly && (
                <Button onClick={onClose} style={{ margin: '0 8px' }} loading={loading}>
                  取消
                </Button>
              )}
              <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }} loading={loading}>
                发送
              </Button>
            </Col>*/}
          </Row>
        </Form>
      </Spin>
    </SFuncModal.Content>,
  );
};
